/**
 * Usability test 01/10/2026 — "Tìm nhanh chức năng" (Ctrl K) chỉ tìm được tên MODULE (8/30 tác vụ thường gặp, 0/30 khi gõ không dấu).
 * Danh mục tác vụ thường dùng: mỗi mục gắn với mục menu cha (`parent` = path của mục nav) — chỉ hiện khi mục cha có trong nav ĐÃ lọc quyền
 * (filterNav: entitlement + capability), nên không lộ màn ngoài quyền; màn đích vẫn tự kiểm quyền (RequireCapability).
 * `keywords` là từ người dùng hay gõ (không dấu cũng được — so khớp bỏ dấu).
 */
export interface TaskCommand {
  key: string;
  label: string;
  parent: string;
  path: string;
  keywords: string;
}

export const TASK_COMMANDS: TaskCommand[] = [
  // Bán hàng
  {
    key: 'task-order-new',
    label: 'Tạo đơn hàng',
    parent: '/orders',
    path: '/orders/new',
    keywords: 'tạo đơn đơn mới đặt hàng lên đơn bán hàng',
  },
  {
    key: 'task-order-quick',
    label: 'Đặt hàng nhanh',
    parent: '/orders',
    path: '/orders/quick',
    keywords: 'đặt nhanh đơn nhanh đặt lại',
  },
  {
    key: 'task-order-quotes',
    label: 'Báo giá',
    parent: '/orders',
    path: '/orders/quotes',
    keywords: 'báo giá quotation chào giá',
  },
  {
    key: 'task-order-returns',
    label: 'Phiếu trả hàng',
    parent: '/orders',
    path: '/orders/returns',
    keywords: 'trả hàng đổi trả hoàn hàng khách trả',
  },
  {
    key: 'task-order-recurring',
    label: 'Đơn định kỳ',
    parent: '/orders',
    path: '/orders/recurring',
    keywords: 'định kỳ đặt định kỳ lịch giao',
  },
  {
    key: 'task-order-exceptions',
    label: 'Đơn bị giữ / ngoại lệ',
    parent: '/orders',
    path: '/orders/exceptions',
    keywords: 'ngoại lệ đơn bị giữ đơn treo chờ kiểm',
  },
  {
    key: 'task-order-import',
    label: 'Nhập đơn từ Excel',
    parent: '/orders',
    path: '/orders/import',
    keywords: 'nhập đơn excel csv import',
  },
  // Khách hàng
  {
    key: 'task-customer-new',
    label: 'Thêm khách hàng',
    parent: '/customers',
    path: '/customers/new',
    keywords: 'thêm khách tạo khách khách hàng mới',
  },
  {
    key: 'task-customer-pipeline',
    label: 'Cơ hội bán hàng',
    parent: '/customers',
    path: '/customers/pipeline',
    keywords: 'cơ hội pipeline deal',
  },
  {
    key: 'task-customer-campaigns',
    label: 'Chiến dịch chăm sóc',
    parent: '/customers',
    path: '/customers/campaigns',
    keywords: 'chiến dịch marketing gửi tin',
  },
  // Giá
  {
    key: 'task-price-lists',
    label: 'Bảng giá',
    parent: '/pricing',
    path: '/pricing',
    keywords: 'bảng giá giá bán sửa giá',
  },
  {
    key: 'task-price-promotions',
    label: 'Khuyến mãi',
    parent: '/pricing',
    path: '/pricing/promotions',
    keywords: 'khuyến mãi voucher coupon mã giảm giá flash sale',
  },
  {
    key: 'task-price-resolve',
    label: 'Tra giá cho khách',
    parent: '/pricing',
    path: '/pricing/resolve',
    keywords: 'tra giá xem giá giá khách',
  },
  // Công nợ
  {
    key: 'task-credit-approvals',
    label: 'Duyệt hạn mức tín dụng',
    parent: '/credit',
    path: '/credit/approvals',
    keywords: 'hạn mức tín dụng duyệt hạn mức',
  },
  {
    key: 'task-credit-aging',
    label: 'Tuổi nợ / nợ quá hạn',
    parent: '/credit',
    path: '/credit/aging',
    keywords: 'tuổi nợ nợ quá hạn công nợ aging',
  },
  {
    key: 'task-credit-dunning',
    label: 'Nhắc nợ',
    parent: '/credit',
    path: '/credit/dunning',
    keywords: 'nhắc nợ đòi nợ thu nợ',
  },
  // Thanh toán
  {
    key: 'task-pay-receipts',
    label: 'Phiếu thu',
    parent: '/payments',
    path: '/payments/receipts',
    keywords: 'phiếu thu thu tiền lập phiếu thu',
  },
  {
    key: 'task-pay-disbursements',
    label: 'Phiếu chi',
    parent: '/payments',
    path: '/payments/disbursements',
    keywords: 'phiếu chi chi tiền trả tiền',
  },
  {
    key: 'task-pay-receivables',
    label: 'Công nợ phải thu',
    parent: '/payments',
    path: '/payments/receivables',
    keywords: 'phải thu công nợ khách',
  },
  {
    key: 'task-pay-payables',
    label: 'Công nợ phải trả',
    parent: '/payments',
    path: '/payments/payables',
    keywords: 'phải trả nợ nhà cung cấp',
  },
  {
    key: 'task-pay-einvoices',
    label: 'Hóa đơn điện tử',
    parent: '/payments',
    path: '/payments/einvoices',
    keywords: 'hóa đơn điện tử hđđt xuất hóa đơn vat',
  },
  {
    key: 'task-pay-recon',
    label: 'Đối soát',
    parent: '/payments',
    path: '/payments/reconciliations',
    keywords: 'đối soát sao kê ngân hàng bảng kê',
  },
  {
    key: 'task-pay-refunds',
    label: 'Hoàn tiền',
    parent: '/payments',
    path: '/payments/refunds',
    keywords: 'hoàn tiền refund trả tiền khách',
  },
  // Kho
  {
    key: 'task-inv-receipt',
    label: 'Nhập kho (phiếu nhập)',
    parent: '/inventory',
    path: '/inventory/vouchers',
    keywords: 'nhập kho phiếu nhập',
  },
  {
    key: 'task-inv-issue',
    label: 'Xuất kho (phiếu xuất)',
    parent: '/inventory',
    path: '/inventory/vouchers',
    keywords: 'xuất kho phiếu xuất',
  },
  {
    key: 'task-inv-search',
    label: 'Tra tồn kho',
    parent: '/inventory',
    path: '/inventory/search',
    keywords: 'tồn kho tra tồn tìm tồn còn hàng',
  },
  {
    key: 'task-inv-counts',
    label: 'Kiểm kê',
    parent: '/inventory',
    path: '/inventory/counts',
    keywords: 'kiểm kê đếm kho kiểm kho',
  },
  {
    key: 'task-inv-transfers',
    label: 'Điều chuyển kho',
    parent: '/inventory',
    path: '/inventory/transfers',
    keywords: 'điều chuyển chuyển kho',
  },
  {
    key: 'task-inv-lots',
    label: 'Lô & hạn dùng',
    parent: '/inventory',
    path: '/inventory/lots',
    keywords: 'lô hạn sử dụng hạn dùng cận date',
  },
  {
    key: 'task-inv-picks',
    label: 'Soạn hàng',
    parent: '/inventory',
    path: '/inventory/picks',
    keywords: 'soạn hàng nhặt hàng picking',
  },
  // Mua hàng
  {
    key: 'task-po-new',
    label: 'Tạo đơn mua (PO)',
    parent: '/supply',
    path: '/supply/orders/new',
    keywords: 'đơn mua po mua hàng đặt nhà cung cấp',
  },
  {
    key: 'task-po-requests',
    label: 'Yêu cầu mua',
    parent: '/supply',
    path: '/supply/requests',
    keywords: 'yêu cầu mua đề nghị mua pr',
  },
  {
    key: 'task-po-suppliers',
    label: 'Nhà cung cấp',
    parent: '/supply',
    path: '/supply/suppliers',
    keywords: 'nhà cung cấp ncc vendor',
  },
  {
    key: 'task-po-receipts',
    label: 'Nhận hàng mua',
    parent: '/supply',
    path: '/supply/receipts',
    keywords: 'nhận hàng grn hàng về',
  },
  // Giao vận
  {
    key: 'task-trip-new',
    label: 'Tạo chuyến giao',
    parent: '/logistics',
    path: '/logistics/trips/new',
    keywords: 'chuyến xe tạo chuyến giao hàng điều xe',
  },
  {
    key: 'task-shipments',
    label: 'Kiện / vận đơn',
    parent: '/logistics',
    path: '/logistics/shipments',
    keywords: 'kiện hàng vận đơn giao hàng',
  },
  {
    key: 'task-fleet',
    label: 'Đội xe & tài xế',
    parent: '/logistics',
    path: '/logistics/fleet',
    keywords: 'đội xe tài xế xe',
  },
  // Sản xuất & OEM
  {
    key: 'task-wo-new',
    label: 'Tạo lệnh sản xuất',
    parent: '/production',
    path: '/production/work-orders/new',
    keywords: 'lệnh sản xuất wo sản xuất',
  },
  {
    key: 'task-qc',
    label: 'Kiểm định chất lượng (QC)',
    parent: '/production',
    path: '/production/qc',
    keywords: 'kiểm định qc chất lượng coa',
  },
  {
    key: 'task-trace',
    label: 'Truy xuất & thu hồi lô',
    parent: '/production',
    path: '/production/trace',
    keywords: 'truy xuất thu hồi recall',
  },
  {
    key: 'task-oem-new',
    label: 'Tạo đơn gia công',
    parent: '/oem',
    path: '/oem/orders/new',
    keywords: 'gia công oem thuê ngoài',
  },
  // CSKH · Loyalty · Social · DMS · HR
  {
    key: 'task-care-tickets',
    label: 'Ticket chăm sóc khách',
    parent: '/care',
    path: '/care/tickets',
    keywords: 'ticket khiếu nại phản ánh hỗ trợ khách',
  },
  {
    key: 'task-care-rmas',
    label: 'Đổi trả / bảo hành (RMA)',
    parent: '/care',
    path: '/care/rmas',
    keywords: 'đổi trả bảo hành rma lỗi hàng',
  },
  {
    key: 'task-loy-members',
    label: 'Hội viên & điểm thưởng',
    parent: '/loyalty',
    path: '/loyalty/members',
    keywords: 'hội viên điểm thưởng tích điểm',
  },
  {
    key: 'task-loy-affiliates',
    label: 'Cộng tác viên (CTV)',
    parent: '/loyalty',
    path: '/loyalty/affiliates',
    keywords: 'cộng tác viên ctv affiliate',
  },
  {
    key: 'task-loy-withdrawals',
    label: 'Rút tiền hoa hồng CTV',
    parent: '/loyalty',
    path: '/loyalty/withdrawals',
    keywords: 'rút tiền hoa hồng ctv',
  },
  {
    key: 'task-social-inbox',
    label: 'Hộp thư mạng xã hội',
    parent: '/social',
    path: '/social/inbox',
    keywords: 'tin nhắn inbox facebook zalo chat',
  },
  {
    key: 'task-social-leads',
    label: 'Khách tiềm năng (lead)',
    parent: '/social',
    path: '/social/leads',
    keywords: 'lead khách tiềm năng',
  },
  {
    key: 'task-dms-visits',
    label: 'Viếng thăm điểm bán',
    parent: '/dms',
    path: '/dms/visits',
    keywords: 'viếng thăm check in điểm bán tuyến',
  },
  {
    key: 'task-dms-outlets',
    label: 'Điểm bán',
    parent: '/dms',
    path: '/dms/outlets',
    keywords: 'điểm bán cửa hàng outlet',
  },
  {
    key: 'task-hr-leave',
    label: 'Xin nghỉ phép',
    parent: '/hr',
    path: '/hr/leave/new',
    keywords: 'nghỉ phép xin nghỉ đơn nghỉ',
  },
  { key: 'task-hr-attendance', label: 'Chấm công', parent: '/hr', path: '/hr/ops', keywords: 'chấm công ca làm công' },
  // Báo cáo · Quản trị
  {
    key: 'task-reports',
    label: 'Báo cáo doanh thu & vận hành',
    parent: '/insight',
    path: '/insight',
    keywords: 'báo cáo doanh thu thống kê bi',
  },
  {
    key: 'task-forecast',
    label: 'Dự báo',
    parent: '/insight',
    path: '/insight/forecast',
    keywords: 'dự báo forecast nhu cầu',
  },
  {
    key: 'task-users',
    label: 'Thêm người dùng / nhân viên',
    parent: '/admin/users',
    path: '/admin/users',
    keywords: 'thêm người dùng nhân viên tài khoản mời',
  },
  {
    key: 'task-roles',
    label: 'Phân quyền / vai trò',
    parent: '/admin/roles',
    path: '/admin/roles',
    keywords: 'phân quyền vai trò quyền',
  },
  {
    key: 'task-audit',
    label: 'Nhật ký hoạt động',
    parent: '/admin/audit',
    path: '/admin/audit',
    keywords: 'nhật ký audit lịch sử thao tác',
  },
];

/** Bỏ dấu tiếng Việt + chữ thường + gộp khoảng trắng — để "phieu thu" khớp "Phiếu thu". */
export function foldVi(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Mọi từ trong câu gõ đều phải có trong văn bản (thứ tự tùy ý). */
export function matchesAll(haystack: string, query: string): boolean {
  const h = foldVi(haystack);
  return foldVi(query)
    .split(' ')
    .filter(Boolean)
    .every((w) => h.includes(w));
}
